<template>
  <div>
    <div class="card_info animated slideInRight">
      <div class="item_carousel card">
        <ImgList :imgUrl="templeData.picture"> </ImgList>
      </div>
      <div class="left_menu_item">
        <div id="card_map"></div>
      </div>

      <div class="left_menu_item card">
        <div class="left_btn">
          <!-- 放 大 -->
          <span @click="zoomIn"> <i class="el-icon-zoom-in"></i>{{$t("templeinfo.zoomin")}}</span>
          <!-- 缩 小 -->
          <span @click="zoomOut"> <i class="el-icon-zoom-out"></i>{{$t("templeinfo.zoomout")}}</span>
        </div>
      </div>

      <div class="left_menu_item">
        <div class="table_box roll">
          <table>
            <tr>
              <!-- 名称 -->
              <th>{{$t("templeinfo.name")}}</th>
              <td>{{templeData.name}}</td>
            </tr>
            <tr>
              <!-- 洲 -->
              <th>{{$t("templeinfo.continent")}}</th>
              <td>{{templeData.continent}}</td>
            </tr>
            <tr>
              <!-- 国家 -->
              <th>{{$t("templeinfo.country")}}</th>
              <td>{{templeData.country}}</td>
            </tr>
            <tr>
              <!-- 省、州 -->
              <th>{{$t("templeinfo.province")}}</th>
              <td>{{templeData.province}}</td>
            </tr>
            <tr>
              <!-- 市 -->
              <th>{{$t("templeinfo.city")}}</th>
              <td>{{templeData.city}}</td>
            </tr>
            <tr>
              <!-- 地址 -->
              <th>{{$t("templeinfo.address")}}</th>
              <td>{{templeData.address}}</td>
            </tr>
            <tr>
              <!-- 修建年代 -->
              <th>{{$t("templeinfo.years")}}</th>
              <td>{{templeData.years}} （{{templeData.dynasty}}）</td>
            </tr>
            <tr>
              <!-- 父庙 -->
              <th>{{$t("templeinfo.father")}}</th>
              <td>{{templeData.fatherId}}</td>
            </tr>
            <tr>
              <!-- 上传者 -->
              <th>{{$t("templeinfo.uploader")}}</th>
              <td>{{templeData.uploader}}</td>
            </tr>
            <tr>
              <!-- 描述 -->
              <th>{{$t("templeinfo.description")}}</th>
              <td>{{templeData.description}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgList from "./ImgList.vue";
export default {
  name: "CardInfo",
  components: {
    ImgList,
    // TimeLine,
  },
  props: {
    info: Object,
  },
  data() {
    return {
      isShow: false,
      moreInfoShow: false,
      moreInfo: {}, //详细信息
      templeData: {},
      cardMaps: null,
      cardMaker: null,
    };
  },
  watch: {
    info: {
      deep: true,
      handler(newVal, oldVal) {
        this.templeData = newVal;
        // 将maker标记的位置设置为获取到的妈祖庙的坐标
        this.cardMaker.setLatLng([newVal.latitude, newVal.longitude]);
        // 调整地图显示，将maker标记置为地图中心
        this.cardMaps.flyTo([newVal.latitude, newVal.longitude], 8);
      },
    },
  },
  mounted() {
    this.initmap(); //加载地图
  },
  methods: {
    // 详细信息 地图
    initmap() {
      var that = this;
      let map = this.$leaflet.map("card_map", {
        minZoom: 1,
        maxZoom: 18,
        // 范围限制
        maxBounds: [
          //south west
          [90, -270],
          //north east
          [-90, 360],
        ],
        center: [25.090924, 119.147698],
        zoom: 3,
        zoomControl: false,
        attributionControl: false,
      });
      this.$leaflet.tileLayer(this.common.mapurl).addTo(map);
      map._onResize();
      // maker样式
      var makerIcon = this.$leaflet.icon({
        iconUrl: "./static/img/maker.png", //maker图片
        shadowUrl: "./static/img/mshadow.png", //maker阴影
        iconSize: [24, 30], // 图标的大小
        shadowSize: [26, 20], // 阴影的大小
        iconAnchor: [12, 30], // 图标的点，该点将与标记的位置相对应
        shadowAnchor: [4, 18], // the same for the shadow
        popupAnchor: [2, -30], //弹出窗口相对于图标打开的点
      });
      // 添加一个不可移动的maker，用来表示妈祖庙位置
      var marker = this.$leaflet
        .marker([25.090574, 119.146299], { icon: makerIcon })
        .addTo(map);
      that.cardMaps = map;
      that.cardMaker = marker;
    },

    // 更多信息滚动条置顶
    scroll() {
      // 滚动条置顶
      // document.querySelector(".el-dialog__wrapper").scrollTop = 0;
    },

    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
      this.moreInfoShow = false;
    },
    zoomIn() {
      // console.log(this.info);
      let coordinates = [this.info.latitude, this.info.longitude];
      this.cardMaps.setView(coordinates, 15);
    },

    zoomOut() {
      let coordinates = [this.info.latitude, this.info.longitude];
      this.cardMaps.flyTo(coordinates, 6);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/_common.scss";

// 左信息
.card_info {
  z-index: 100;
  width: 100%;
  height: calc(100vh - 6.2rem);
  overflow: hidden;
  border-radius: $r-min;
  background-color: $c-white;
  opacity: 0.9;
  box-shadow: $shadow;
  transition: margin-right 0.5s;
  .item_carousel {
    width: 90%;
    height: 14rem;
    margin: $m-lit auto;
    // padding: $m-mid;
    overflow: hidden;
  }

  #card_map {
    height: 14rem;
    width: 100%;
    border-radius: $r-mid;
    box-sizing: border-box;
    box-shadow: $shadow;
  }
  .left_menu_item {
    width: 90%;
    margin: 0 auto;
    margin-top: $m-lit;
    padding: $m-lit;
    .left_btn {
      font-size: $f-lit;
      display: flex;
      justify-content: space-around;
      align-items: center;
      span {
        opacity: 0.8;
        cursor: pointer;
        &:hover {
          color: $c-main;
        }
      }
    }

    .table_box {
      // max-height: 26rem;
      overflow: hidden;
      overflow-y: auto;
      border-radius: $r-min;
      max-height: calc(100vh - 35rem);
      // max-height: calc(100vh - 40rem);
      table {
        width: 100%;
        color: $c-text-main;
        border-collapse: collapse;
        tr,
        th,
        td {
          border: 1px solid $c-main-light;
          // line-height: 1.5rem;
          font-size: $f-lit;
          padding: 0;
          margin: 0;
        }
        th {
          // border-right: 1px solid $c-main-light;

          width: 6rem;
        }
      }
    }
  }
  .el-carousel {
  }
}
.clicked {
  color: $c-main;
}

.more_info {
  z-index: 100;
  width: calc(100vw - 30% - 3rem);
  height: calc(100vh - $head-height - 16rem);
  left: 2rem;
  bottom: 1.6rem;
  // border: 1px solid red;
  // top: $head-height;
  position: absolute;
  border-radius: $r-mid;
  // background-color: $c-glass-white;
  // backdrop-filter: $d-glass;
  // border-left: $b-glass;
  background: $c-white;
  box-shadow: $shadow;
  // transition: all 0.3s;
  overflow: hidden;
  overflow-y: auto;

  .menu_item {
    background: $c-white;
    width: 90%;
    margin: $m-lit auto;
    padding: $m-mid;
    overflow: hidden;

    .more_title {
      color: $c-main;
    }
    .more_table {
      table {
        width: 100%;
        color: $c-text-main;
        border-collapse: collapse;
        min-height: 20rem;
        tr,
        th,
        td {
          border: 1px solid $c-main-light;
          // line-height: 1.5rem;
          font-size: $f-lit;
          padding: 0 $m-lit;
          margin: 0;
        }
        th {
          // border-right: 1px solid $c-main-light;
          width: 6rem;
        }
      }
    }
  }
}
</style>
